import axios from 'axios';
export /**
 * 生成axios实例
 * @param {...Parameters<typeof axios.create>} params
 */ const requestCreate = (config, errHandler) => {
    const request = axios.create(config);
    /** response interceptor */
    request.interceptors.response.use((response) => {
        return response.data;
    }, errHandler);
    return request;
};
/**
 * timeout为0的request
 * @internal 内部调用
 */
export const request = requestCreate({
    timeout: 0
});
